//pricing table that will be loaded from tha backend

export const VIEW_CONTACTS = "VIEW_CONTACTS";

export const getPrice = (product) => {
  const pricingList = {
    [VIEW_CONTACTS]: 10,
  };

  if (pricingList[product]) return pricingList[product];

  throw new Error(`Product price ${product} not found`);
};
